import { UliItemActionParams } from '../../models/uli-item-overview.model';
import { Language } from '../../../../../../../common';
import { UliAttachmentsModel } from '../../../models/allocation-view-uli-item.model';

export class UliItemAttachmentsGetAttachments {
  public static readonly type = '[UliItemAttachments] Get Attachments';

  constructor(
    public payload: {
      hubId: number;
      params: UliItemActionParams;
      languageCode: Language;
    },
  ) {}
}

export class UliItemAttachmentsDownloadPdf {
  public static readonly type = '[UliItemAttachments] Download PDF';

  constructor(public payload: UliAttachmentsModel) {}
}

export class UliItemAttachmentsSetInitialState {
  public static readonly type = '[UliItemAttachments] Set Initial State';
}
